var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M402.572 223.732C402.572 140.408 332.217 72.9313 247.655 77.1912C171.052 81.6215 110.712 144.583 109 221.176C109 259.259 123.208 294.701 148.2 322.561C189.026 366.097 183.805 416.279 183.805 416.279C183.805 425.991 191.851 434 201.608 434H310.307C320.064 434 328.109 425.991 328.965 416.279C328.965 416.279 322.974 367.12 363.714 323.413C388.707 296.746 403 261.304 403 223.732H402.572Z",
    fill: "#69EBD0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M275.375 157C233.854 172.164 211.726 198.659 215.998 236.485C210.419 233.401 207.633 224.302 206.343 212.034C196.518 224.558 189 240.318 189 257.953C189 285.641 203.951 314.606 228.898 327.896C236.451 331.517 243.251 333.544 250.684 334.43C225.139 330 209.846 294.986 226.848 273.433C227.531 279.771 235.315 289.534 238.211 291.153C231.154 273.007 232.128 243.615 251.88 233.307C252.026 267.043 285.371 271.303 279.22 307.339C284.91 300.907 287.763 290.641 288.276 282.548C297.332 303.165 290.224 319.692 277.34 328.041C270.01 332.82 262.902 334.89 256.238 334.916C317.58 337.847 339.537 263.439 309.977 217.35C309.294 235.837 305.841 249.638 299.724 260.032C297.127 225.87 250.086 190.259 275.461 157.801L275.375 157Z",
    fill: "#2A9DF4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.82702d8e899eba8c620022bd22bd0563.svg";
export { ForwardRef as ReactComponent };